import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import "./index.scss"
import Button from "react-bootstrap/Button"
import { ConfirmDialog } from "components"

import { auth, teamStatus, message } from "state_management"
import useT from "utils/hooks/useT"

export default function ManageScreen() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const memberId = useSelector((state) => state.auth.memberId)
  const currentMemberShowOnPlan = useSelector((state) => state.auth.memberId && state.members[state.auth.memberId] ? state.members[state.auth.memberId].showOnPlan : true)
  const isViewOnly = useSelector((state) => state.auth.isViewOnly)
  const isInPlanningMode = useSelector((state) => state.teamStatus.isInPlanningMode)
  const isCurrentPlanner = useSelector((state) => state.teamStatus.isCurrentPlanner)
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)
  const { t } = useT("messages")
  const { t: tc } = useT("common")

  return (
    <div className="ManageScreen-main-container">
      {showLogoutConfirm && (
        <ConfirmDialog
          onCancel={() => setShowLogoutConfirm(false)}
          onConfirm={() => {
            setShowLogoutConfirm(false)
            dispatch(teamStatus.discardPlanningModeChanges())
              .then(() => {
                dispatch(auth.logout())
                navigate("/login")
              })
              // Overwrite default error message
              // TODO: Find a better way to do this!
              .catch((e) => {
                if (e.name === "IAPinUseError") {
                  dispatch(message.warning(t("adhoc.iapRunning")))
                } else {
                  dispatch(message.error(t("adhoc.failedDiscardNotLoggedOut")))
                }
              })
          }}
        >
          <h4>{tc("simulationModeLogoutWarning")}</h4>
        </ConfirmDialog>
      )}
      <div className="ManageScreen-item ManageScreen-Logo">
        <p>{tc("plannertech")}</p>
      </div>
      <div className="ManageScreen-item ManageScreen-TeamPlanButton">
        <Button title={tc("teamPlan")} onClick={() => navigate(`/`)}>
          {tc("teamPlan")}
        </Button>
      </div>
      {currentMemberShowOnPlan && (
      <div className="ManageScreen-item ManageScreen-MemberPlanButton">
        <Button title={tc("memberPlan")} onClick={() => navigate(`/member/${memberId}`)}>
          {tc("memberPlan")}
        </Button>
      </div>
      )}
      {!isViewOnly && (
      <div className="ManageScreen-item ManageScreen-MemberPlanButton">
        <Button title={tc("qcLibrarian")} onClick={() => navigate(`/librarian`)}>
          {tc("qcLibrarian")}
        </Button>
      </div>
      )}
      <div className="ManageScreen-item Managescreen-Logout">
        <Button
          title={tc("logout")}
          variant="secondary"
          onClick={() => {
            if (isInPlanningMode && isCurrentPlanner) {
              setShowLogoutConfirm(true)
            } else {
              dispatch(auth.logout()).then(() => navigate("/login"))
            }
          }}
        >
          {tc("logout")}
        </Button>
      </div>
    </div>
  )
}
